import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import {
  VApp,
  VCard,
  VLayout,
  VTextField,
  VAlert
  /* other imports ... */
} from "vuetify";
import "vuetify/src/stylus/app.styl";
Vue.use(Vuetify, {
  iconfont: "md",
  components: {
    VApp,
    VCard,
    VLayout,
    VTextField,
    VAlert
    /* other imports */
  }
});
